import { axiosAuth } from './axiosInstances'

// KHAN-235: apps.Roles -> apps.roles, api/roles/listAllRoles/ -> recurso REST
// api/roles/ (GET). La funcion exportada conserva su firma y la forma de la
// respuesta (arreglo plano de {rolesid, role}).
export async function list_All_Roles() {
    return axiosAuth().get('/roles/')
}
